import { makeStyles } from "@material-ui/core/styles";

export const useWorkOrderProductsTabStyles = makeStyles(() => ({
  marginRight: {
    marginRight: "15px",
  },
}));
